export default __webpack_public_path__ + "images/logo.b7fcc32e.svg";